import { Typography, Spacer } from "@fullscript/aviary-web";

import { getSubtleFootnoteProps } from "@shared/layouts/PageFooter/getSubtleFootnoteProps";

import * as styles from "./CustomDisclaimer.styles";

type Alignment = "center" | "start" | "end";

interface Props {
  disclaimer?: string | null;
  alignment?: Alignment;
  spacer?: boolean;
  isInverseTheme?: boolean;
}

const CustomDisclaimer = ({
  disclaimer,
  spacer = true,
  alignment = "start",
  isInverseTheme = false,
}: Props) => {
  if (!disclaimer) return null;

  return (
    <>
      {!!spacer && <Spacer size="large" />}
      <div css={styles.container(alignment)}>
        <div css={styles.content}>
          <Typography {...getSubtleFootnoteProps(isInverseTheme)}>{disclaimer}</Typography>
        </div>
      </div>
    </>
  );
};

export { CustomDisclaimer };
